import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ColorPickerEditor from 'common/components/ColorPicker';
import FontPickerEditor from 'common/components/FontPicker';

import {
    setFormButtonTextFont,
    setFormButtonTextFontSize,
    setFormButtonTextColorDefault,
    setFormButtonTextColorHover,
} from 'common/entities/form/styleConfiguration/actions';
import {
    DEFAULT_FONT,
    DEFAULT_FONT_SIZE,
    DEFAULT_BUTTON_LABEL_COLOR,
} from 'common/entities/form/styleConfiguration/defaultValues';
import { getDefaultStyle, styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';
import { getFormButtonTextStyles } from 'common/entities/form/styleConfiguration/selectors';
import { getColors } from 'common/entities/color/selectors';
import { getFonts } from 'common/entities/font/selectors';
import { getFormId } from '../../../../selectors';

import { COLOR_PICKER_DEFAULT, COLOR_PICKER_HOVER } from '../../../../constants/formStyleLabels';
import { BUTTON_QA } from '../../../../utils/qaIdConstants';

const ButtonTextPanel = ({ formId, font, fontSize, defaultColor, hoverColor, colorList, fontList, ...props }) => (
    <React.Fragment>
        <FontPickerEditor
            fontFamilyList={fontList}
            defaultFontFamily={font}
            onChangeFontFamily={(id) => props.setFormButtonTextFont(formId, id)}
            defaultFontSize={fontSize}
            onChangeFontSize={(size) => props.setFormButtonTextFontSize(formId, size)}
            fontFamilyQa={`${BUTTON_QA}--fontFamily`}
            fontSizeQa={`${BUTTON_QA}--fontSize`}
        />
        <ColorPickerEditor
            colorList={colorList}
            firstColorLabel={COLOR_PICKER_DEFAULT}
            firstColor={defaultColor}
            changeFirstColor={(id) => props.setFormButtonTextColorDefault(formId, id)}
            secondColorLabel={COLOR_PICKER_HOVER}
            secondColor={hoverColor}
            changeSecondColor={(id) => props.setFormButtonTextColorHover(formId, id)}
            qaId={BUTTON_QA}
        />
    </React.Fragment>
);

ButtonTextPanel.propTypes = {
    defaultColor: styleShapePropTypes,
    hoverColor: styleShapePropTypes,
    font: styleShapePropTypes,
    fontSize: PropTypes.number,
    formId: PropTypes.string.isRequired,
    colorList: PropTypes.arrayOf(PropTypes.object).isRequired,
    fontList: PropTypes.arrayOf(PropTypes.object).isRequired,
    setFormButtonTextFont: PropTypes.func.isRequired,
    setFormButtonTextFontSize: PropTypes.func.isRequired,
    setFormButtonTextColorDefault: PropTypes.func.isRequired,
    setFormButtonTextColorHover: PropTypes.func.isRequired,
};

ButtonTextPanel.defaultProps = {
    defaultColor: getDefaultStyle(DEFAULT_BUTTON_LABEL_COLOR),
    hoverColor: getDefaultStyle(DEFAULT_BUTTON_LABEL_COLOR),
    font: getDefaultStyle(DEFAULT_FONT),
    fontSize: DEFAULT_FONT_SIZE,
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const colorList = getColors(state);
    const fontList = getFonts(state);
    const { colors, font, fontSize } = getFormButtonTextStyles(state, formId);

    const { default: defaultColor, hover: hoverColor } = colors;

    return {
        formId,
        defaultColor,
        hoverColor,
        font,
        fontSize,
        colorList,
        fontList,
    };
};

const mapDispatchToProps = {
    setFormButtonTextFont,
    setFormButtonTextFontSize,
    setFormButtonTextColorDefault,
    setFormButtonTextColorHover,
};

export default connect(mapStateToProps, mapDispatchToProps)(ButtonTextPanel);
